<template>
    <basicSearch :onSearchApi="onSearchApi" placeholder="搜索赛事" v-bind="$attrs" v-on="$listeners"></basicSearch>
</template>

<script>

import basicSearch from '@/components/basic/search.vue';
import { searchUniqueTournament } from '@/api/ballsports/base/unique_tournament';

export default {
    name: "unique-tournament-search",
    components: {
        basicSearch
    },
    data () {
        return {
            onSearchApi: searchUniqueTournament,
        }
    }
}
</script>